<template>
  <div v-if="!(routeName === 'register' || $route.path.indexOf('/info') !== -1|| $route.path.indexOf('/ekp') !== -1)" class="sideBar">
    <transition name="slide-fade">
      <div v-if="isExpand">
        <a v-for="(item, index) in menus" :key="index" :href="item.url" target="_blank">
          <div class="ico">
            <span :class="['iconfont', item.icon]"></span>
          </div>
          <div class="txt">{{ item.name }}</div>
          <span class="count" v-if="item.menuId === 'RCO200103090950001' && notificationCount > 0">{{ notificationCount }}</span>
          <span class="count" v-if="item.menuId === 'RCO200103090950002' && auditCount > 0">{{ auditCount }}</span>
        </a>
        <a href="javascript:;" @click="gotoInfo">
          <div class="ico">
            <span class="iconfont icon-shezhi"></span>
          </div>
          <div class="txt">设置</div>
        </a>
      </div>
    </transition>
    <a href="javascript:;" @click="isExpand = !isExpand" style="background: #1089c8">
      <div class="ico">
        <span :class="['iconfont', isExpand ? 'icon-arrow-right-circle' : 'icon-arrow-left-circle']" style="color: #fff"></span>
      </div>
      <div class="txt" style="color: #fff">{{ isExpand ? '收缩' : '展开' }}</div>
    </a>
  </div>
</template>

<script>
import { findMenus, queryMenuCount } from '@/api/app'
import { onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
export default {
  name: 'AppSidebar',
  setup () {
    const menus = ref(null)
    const routeName = ref('')
    const route = useRoute()
    watch(
      () => route.name,
      newVal => {
        routeName.value = newVal
        if (route.name === 'home' || route.name === 'attention') {
          clearInterval(timerId)
          timerId = setInterval(() => {
            getNotificationCount('NOTIFICATION')
            getNotificationCount('AUDIT')
          }, 60 * 1000)
        }
      },
      { immediate: true }
    )

    const router = useRouter()
    const gotoInfo = () => {
      const routeData = router.resolve({ name: 'info' })
      window.open(routeData.href, '_blank')
    }

    findMenus().then(res => {
      if (res.code === 'SUCCESS') {
        menus.value = res.data
      }
    })

    const notificationCount = ref(0)
    const auditCount = ref(0)
    const getNotificationCount = type => {
      queryMenuCount({ param: { type } }).then(res => {
        if (res.code === 'SUCCESS') {
          if (type === 'NOTIFICATION') {
            notificationCount.value = res.data
          } else {
            auditCount.value = res.data
          }
        }
      })
    }

    getNotificationCount('NOTIFICATION')
    getNotificationCount('AUDIT')

    let timerId = null
    onMounted(() => {
      clearInterval(timerId)
    })

    onBeforeUnmount(() => {
      clearInterval(timerId)
    })

    document.addEventListener('visibilitychange', () => {
      clearInterval(timerId)

      if (!document.hidden) {
        if (route.name === 'home' || route.name === 'attention') {
          getNotificationCount('NOTIFICATION')
          getNotificationCount('AUDIT')

          timerId = setInterval(() => {
            getNotificationCount('NOTIFICATION')
            getNotificationCount('AUDIT')
          }, 60 * 1000)
        }
      }
    })

    // const { notificationCount } = findMenuCount('NOTIFICATION')
    // const { auditCount } = findMenuCount('AUDIT')

    const isExpand = ref(true)

    return {
      routeName,
      gotoInfo,
      menus,
      isExpand,
      notificationCount,
      auditCount
    }
  }
}

/* const findMenuCount = type => {
  const notificationCount = ref(0)
  const auditCount = ref(0)
  queryMenuCount({ param: { type } }).then(res => {
    if (res.code === 'SUCCESS') {
      if (type === 'NOTIFICATION') {
        notificationCount.value = res.data
      } else {
        auditCount.value = res.data
      }
    }
  })
  let timerId = null
  timerId = setInterval(() => {
    queryMenuCount({ param: { type } }).then(res => {
      if (res.code === 'SUCCESS') {
        if (type === 'NOTIFICATION') {
          notificationCount.value = res.data
        } else {
          auditCount.value = res.data
        }
      }
    })
  }, 1000 * 60)

  onBeforeUnmount(() => {
    clearInterval(timerId)
  })
  return {
    notificationCount,
    auditCount
  }
} */
</script>

<style lang="less" scoped>
.sideBar {
  position: fixed;
  top: 160px;
  right: 0;
  z-index: 9;
  width: 100px;

  a {
    position: relative;
    display: block;
    width: 100px;
    height: 75px;
    box-sizing: border-box;
    padding-top: 15px;
    text-align: center;
    background: #fff;
    transition: all 0.5s ease;
    box-shadow: 0 0 5px 0 rgb(0 0 0 / 10%);
    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background: #1089c8;

      .ico {
        .img1 {
          opacity: 1;
        }

        span {
          color: #fff;
        }
      }

      .txt {
        color: #fff;
      }
    }

    .ico {
      margin: 0 auto;
      width: 28px;
      height: 28px;
      position: relative;

      img {
        width: 28px;
      }

      .img1 {
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0;
        transition: all 0.5s ease;
      }

      span {
        color: #1089c8;
        font-size: 24px;
        transition: all 0.5s ease;
      }
    }

    .txt {
      padding-top: 3px;
      color: #1089c8;
      transition: all 0.5s ease;
    }

    .count {
      position: absolute;
      top: 20px;
      left: 45px;
      box-sizing: border-box;
      min-width: 16px;
      padding: 0 3px;
      color: #fff;
      font-weight: 500;
      font-size: 12px;
      line-height: 1.2;
      text-align: center;
      background-color: #ee0a24;
      border: 1px solid #fff;
      border-radius: 16px;
      transform: translate(50%, -50%);
      transform-origin: 100%;
    }
  }
}

@media screen and (max-width: 1024px) {
  .sideBar {
    top: 130px;
    width: 65px;

    a {
      width: 65px;
      height: 60px;
      padding-top: 10px;
      &:hover {
        background: #fff;
        .ico {
          span {
            color: #1089c8;
          }
        }
        .txt {
          color: #1089c8;
        }
      }

      .ico {
        width: 24px;
        height: 24px;

        img {
          width: 24px;
        }
      }

      .count {
        top: 15px;
        left: 25px;
      }
    }
  }
}

.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>
